export enum UtmAttributeEnum {
  MEDIUM = "medium",
  SOURCE = "source",
  CAMPAIGN = "campaign",
  TERM = "term",
  CONTENT = "content",
  GCLID = "gclid",
}
